// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","left":"Footer_left__GEL1z","center":"Footer_center__lfPOL","right":"Footer_right__HT2LI"};